import { SelectableItem } from '../interfaces/job-information-form.interface';

export const titles: SelectableItem[] = [
  { key: 'UNKNOWN', label: '' },
  { key: 'DR', label: $localize`:@@utilUserData-jobInformationFields-title-dr:Dr.` },
  { key: 'PROF', label: $localize`:@@utilUserData-jobInformationFields-title-prof:Prof.` },
  { key: 'PROF_DR', label: $localize`:@@utilUserData-jobInformationFields-title-prof-dr:Prof. Dr.` },
];
